import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Waypoint } from 'src/app/data/model/waypoints';
import { OdsWaypointsService } from 'src/app/features/ods-waypoints/services/ods-waypoints.service';
import { BaseDialogComponent } from 'src/app/shared/base/base-dialog.component';

@Component({
  standalone: false,
  selector: 'app-ods-waypoints-dialog',
  templateUrl: './ods-waypoints-dialog.component.html',
  styleUrls: ['./ods-waypoints-dialog.component.scss'],
  providers: [OdsWaypointsService],
})
export class OdsWaypointsDialogComponent extends BaseDialogComponent<
  Waypoint,
  OdsWaypointsService,
  OdsWaypointsDialogComponent,
  WaypointsDialogParam
>
implements OnInit
{
  ods$ = this.service.ods$;


  constructor(
    @Inject(MAT_DIALOG_DATA) data: WaypointsDialogParam,
    dialogRef: MatDialogRef<OdsWaypointsDialogComponent>,
    service: OdsWaypointsService,
  ) {
    super(data, dialogRef, service);
  }

  ngOnInit(): void {
    if (this.data.id) {
      this.service.load(this.data?.id);
    }
    this.service.loadODS();
  }
}
export type WaypointsDialogParam = {
  id: number;
  service_order: number;
};